import { appColors, CareerCategory } from '@backrs_ui/common-ui';

import { CareerPathWithScore } from '@backrs_ui/grow-ui/src/models/models';

import { View, Text, StyleSheet } from '@react-pdf/renderer';

import { getCareerPathFitColor, sortCareerSuggestions } from '../util/results.util';

type CareerCategoryGroupPDFProps = Readonly<{
  index: number;
  careerPathSuggestions: CareerPathWithScore[];
  category: CareerCategory;
}>;

export const CareerCategoryGroupPDF = ({
  index,
  careerPathSuggestions,
  category,
}: CareerCategoryGroupPDFProps) => {
  // sort the career path suggestions by the category, but keep the original array index so we can correctly color the circles
  const suggestionsWithOriginalIndex = sortCareerSuggestions(careerPathSuggestions, category);

  return (
    <View key={index} style={styles.categoryGroup}>
      <View style={styles.chip}>
        <Text style={styles.chipTitle}>{category.name}</Text>
      </View>

      <View style={{ paddingLeft: 4 }}>
        {suggestionsWithOriginalIndex.map(({ path, originalIndex }) => {
          const fitColor = getCareerPathFitColor(path.scoreSection);

          return (
            <View style={styles.lineItemContainer} key={originalIndex}>
              <View style={[styles.smallCircle, { backgroundColor: fitColor }]} />
              <Text style={styles.careerPathName}>{path.careerPath.name}</Text>
            </View>
          );
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  chip: {
    backgroundColor: appColors.color.blue1,
    padding: 4,
    paddingHorizontal: 12,
    borderRadius: 16,
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    display: 'flex',
    minHeight: 23,
    maxHeight: 23,
    marginBottom: 4,
  },
  chipTitle: {
    fontSize: 10,
    color: 'white',
    fontWeight: 'bold',
  },
  categoryGroup: {
    width: '33.33%',
    marginTop: 16,
    paddingRight: 16,
  },
  categoryTitle: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  lineItemContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 3,
  },
  smallCircle: {
    borderRadius: '50%',
    height: 7,
    width: 7,
    marginRight: 8,
  },
  careerPathName: {
    fontSize: 9,
  },
});
